import {HttpEvent, HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {Observable, catchError, from, of, switchMap, throwError} from 'rxjs';
import {AuthSessionInvalidationService} from './auth-session-invalidation.service';
import {AuthError} from './auth.service';

function shouldSkipRedirect(url: string): boolean {
  return url.includes('/v1/auth/login')
    || url.includes('/v1/auth/register')
    || url.includes('/v1/auth/verify-email')
    || url.includes('/v1/auth/forgot-password')
    || url.includes('/v1/auth/reset-password')
    || url.includes('/v1/auth/google')
    || url.includes('/v1/auth/refresh')
    || url.includes('/v1/auth/logout')
    || url.includes('/v1/push/registrations/deactivate')
    || url.includes('/v1/auth/google-diagnostics')
    || url.includes('/v1/pricing-plans')
    || /\/v1\/releases(?:\?|$)/.test(url);
}

function isUnauthorizedError(error: unknown): boolean {
  return (error instanceof HttpErrorResponse || error instanceof AuthError)
    && error.status === 401;
}

@Injectable()
export class AuthRedirectInterceptor implements HttpInterceptor {
  constructor(
    private readonly injector: Injector,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (!isUnauthorizedError(error) || shouldSkipRedirect(request.url)) {
          return throwError(() => error);
        }

        return from(this.redirectToLogin()).pipe(
          catchError(() => of(undefined)),
          switchMap(() => throwError(() => error)),
        );
      }),
    );
  }

  private async redirectToLogin(): Promise<void> {
    await this.injector.get(AuthSessionInvalidationService).handleInvalidSession();
  }
}
